import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = 'Understand, select, start, control, protect, test and troubleshoot industrial electric motors and VFDs. 6 professional volumes, 5 exclusive bonuses and instant access.';
export function App() {
  useEffect(() => {
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="min-h-screen w-full overflow-hidden bg-background font-sans text-muted antialiased" data-id="element-0" data-mp="nur6e0oh68xc">
      <MetaPixel data-id="element-1" data-mp="st2heeqiaph5" />
      <main data-id="element-2" data-mp="swqchiblnjxz">
        <Hero data-id="element-3" data-mp="swgmvvugvest" />
        <LookInsideCarousel data-id="element-4" data-mp="3684hdq2uasw" />
        <ProblemSection data-id="element-5" data-mp="35gld2do25ji" />
        <SystemSection data-id="element-6" data-mp="34nabp7octvk" />
        <ModulesSection data-id="element-7" data-mp="38b66v0ldsdg" />
        <BonusSection data-id="element-8" data-mp="3udaw269tuj3n" />
        <UrgencySection data-id="element-9" data-mp="3ubriinfk2m5k" />
        <PricingSection data-id="element-10" data-mp="3ucjdbw1bwfus" />
        <GuaranteeSection data-id="element-11" data-mp="d4nwrk0ubq3z" />
        <FAQ data-id="element-12" data-mp="d4xphfd9sbdd" />
        <ClosingSection data-id="element-13" data-mp="d3mm3gnql5ms" />
        <SummaryTable data-id="element-14" data-mp="d3wbp34vdary" />
        <FinalCta data-id="element-15" data-mp="d2bfl92wpjrz" />
      </main>
      <Footer data-id="element-16" data-mp="85bb32lpgp2z" />
      <PurchaseNotification data-id="element-17" data-mp="86mcivrohkqx" />
    </div>;
}